import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=4221139c"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports